(function() {
  const translations = {
    en: 'ADD TO CART',
    es: 'AGREGAR AL CARRITO',
    fr: 'Ajouter au panier',
    ph: 'Idagdag sa cart'
  };

  function translateEveyButton(root = document) {
    const lang = document.documentElement.lang || 'en';
    const btns = root.querySelectorAll('[data-evey-loaded="ready"] span, .product-form__submit span');
    let translated = false;

    btns.forEach(btn => {
      const current = btn.textContent.trim().toLowerCase();
      // Check for "add to cart" text in a flexible way
      if (translations[lang] && current.includes('add to cart')) {
        btn.textContent = translations[lang];
        translated = true;
      }
    });

    return translated;
  }

  function runTranslation() {
    if (!translateEveyButton()) {
      // Retry after 200ms if button not found yet
      setTimeout(runTranslation, 200);
    }
  }

  // Start translation once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runTranslation);
  } else {
    runTranslation();
  }

  // Watch for dynamically added buttons
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) translateEveyButton(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also re-run on Shopify section updates
  window.addEventListener('shopify:section:load', () => setTimeout(runTranslation, 100));
  window.addEventListener('shopify:section:reorder', () => setTimeout(runTranslation, 100));
})();